import React from "react";
import { useStyles } from "components/layout/CommonStyles";
import { useTranslation } from "react-i18next";

export default function NoItemsToView({ messageLabel, messageDesc }) {
  const classes = useStyles();
  const [t] = useTranslation();
  return (
    <div className={classes.noParticipantsMessage}>
      <h2>{t(messageLabel)}</h2>
      <h4>{t(messageDesc)}</h4>
    </div>
  );
}
